import { defineAsyncComponent } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import { TIMESTAMP_TYPES, TIMESTAMP_TYPE_CREATED_AT } from '~/vue_shared/components/resource_lists/constants';
import { COMPONENT_NAME } from './constants';
export default {
    name: COMPONENT_NAME,
    components: {
        NestedGroupsProjectsListItem: defineAsyncComponent(()=>import('/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/nested_groups_projects_list/nested_groups_projects_list_item.vue?vue3'))
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        timestampType: {
            type: String,
            required: false,
            default: TIMESTAMP_TYPE_CREATED_AT,
            validator (value) {
                return TIMESTAMP_TYPES.includes(value);
            }
        },
        includeMicrodata: {
            type: Boolean,
            required: false,
            default: false
        },
        /**
     * Allows the parent component to override `isExpanded`.
     * This is needed when searching as we want the tree to be open after searching.
     */ expandedOverride: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'click-avatar',
        'hover-stat',
        'hover-visibility',
        'load-children',
        'refetch'
    ]
};
